import React, { useEffect, useRef } from 'react';
import { useArticles } from '../context/ArticleContext';
import { useAuth } from '../context/AuthContext';
import { 
  notifyNewPublication, 
  getLastNotifiedArticleId, 
  setLastNotifiedArticleId, 
  areNotificationsEnabled 
} from '../services/notificationService';
import { getArticleUrl } from '../utils/slug';

export const PublicationNotificationWatcher: React.FC = () => {
  const { publishedArticles } = useArticles();
  const { isMember, currentUser } = useAuth();
  const initialCheckDone = useRef(false);

  useEffect(() => {
    if (!publishedArticles || publishedArticles.length === 0) return;

    // Apenas notifica se o usuário for membro/inscrito, push ativo ou tiver notificações ativadas
    const isPushSubscribed = typeof window !== 'undefined' && localStorage.getItem('literafan_push_subscribed') === 'true';
    const notificationsActive = isMember || areNotificationsEnabled() || Boolean(currentUser) || isPushSubscribed;
    if (!notificationsActive) return;

    const latestArticle = publishedArticles[0];
    if (!latestArticle || !latestArticle.id) return;

    const lastNotifiedId = getLastNotifiedArticleId();

    // Na primeira execução após carregar a página
    if (!initialCheckDone.current) {
      initialCheckDone.current = true;

      // Se é a primeira vez que o usuário acessa com notificações ativas
      if (!lastNotifiedId) {
        setLastNotifiedArticleId(latestArticle.id);
        return;
      }

      // Se há um novo artigo que ainda não foi notificado para esse inscrito
      if (lastNotifiedId !== latestArticle.id) {
        setLastNotifiedArticleId(latestArticle.id);
        
        // Pequeno delay para a página renderizar suavemente antes do aviso
        const timer = setTimeout(() => {
          notifyNewPublication({
            id: latestArticle.id,
            title: `Novo Artigo: ${latestArticle.title}`,
            body: latestArticle.excerpt || 'Um novo artigo acaba de ser publicado no Literafan. Venha conferir!',
            url: `#${getArticleUrl(latestArticle)}`,
            imageUrl: latestArticle.imageUrl,
            type: 'article'
          });
        }, 2000);

        return () => clearTimeout(timer);
      }
    } else {
      // Quando um novo artigo é publicado enquanto o usuário está navegando no site
      if (lastNotifiedId && lastNotifiedId !== latestArticle.id) {
        setLastNotifiedArticleId(latestArticle.id);
        notifyNewPublication({
          id: latestArticle.id,
          title: `Publicado Agora: ${latestArticle.title} 📚`,
          body: latestArticle.excerpt || 'Novo artigo disponível na revista Literafan.',
          url: `#${getArticleUrl(latestArticle)}`,
          imageUrl: latestArticle.imageUrl,
          type: 'article'
        });
      }
    }
  }, [publishedArticles, isMember, currentUser]);

  return null;
};

export default PublicationNotificationWatcher;
